import { HttpClient, HttpParams } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Aditivo} from '../model/Aditivo';
import {ColecaoAditivo} from '../model/ColecaoAditivo';
import {map} from 'rxjs/operators';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import {ParamAditivo} from '../model/ParamAditivo';
import {ResultadoEnvioAditivo} from '../model/ResultadoEnvioAditivo';
import {formatDate} from '@angular/common';
import {ResultadoAprovacaoAditivo} from '../model/ResultadoAprovacaoAditivo';
import {Aviso} from '../model/Aviso';
import {ColecaoAviso} from '../model/ColecaoAviso';
import { ResultadoValidacaoAditivo } from '../model/ResultadoValidacaoAditivo';

@Injectable({
  providedIn: 'root'
})
export class AditivoService {

  private BASE_URL = './rest/seguro/aditivo';

  constructor(private http: HttpClient) {
  }

  enviarAditivo(paramAditivo: ParamAditivo): Observable<ResultadoEnvioAditivo> {
    return this.http.post(`${this.BASE_URL}/`, paramAditivo, blockUi()).pipe(map(r => Object.assign(new ResultadoEnvioAditivo(), r)));
  }

  obterAditivo(idAditivo: string): Observable<Aditivo> {
    return this.http.get(`${this.BASE_URL}/${idAditivo}`, blockUi()).pipe(map(a => Object.assign(new Aditivo(), a)));
  }

  validarAditivo(idAditivo: string): Observable<ResultadoValidacaoAditivo> {
     return this.http.post(`${this.BASE_URL}/${idAditivo}/validar`, blockUi()).pipe(map(a => Object.assign(new ResultadoValidacaoAditivo(), a)));
  }

  obterAvisosFluxoAprovacao(idAditivo: string): Observable<ColecaoAviso> {
    return this.http.get(`${this.BASE_URL}/${idAditivo}/avisosFluxoAprovacao`, blockUi()).pipe(map(a => Object.assign(new ColecaoAviso(), a)));
  }

  buscarAnaliseAditivo(idAditivo: string): Observable<Aviso[]> {
    return this.http.get<Aviso[]>(`${this.BASE_URL}/comentarios-analise-aditivo/${idAditivo}`, blockUi());
  }

  pesquisaAditivoAvancada(protocoloInicio: Date, protocoloFim: Date, situacao: string, proposta: string, ano: number, pac: string, comprador: string): Observable<ColecaoAditivo> {
    function date2str(data: Date): string {
      if (data == null) {
        return null;
      }
      return formatDate(data, 'yyyy-MM-dd', 'en-US');
    }

    let params = new HttpParams();
    if (protocoloInicio) {
      params = params.set('protocoloInicio', date2str(protocoloInicio));
    }
    if (protocoloFim) {
      params = params.set('protocoloFim', date2str(protocoloFim));
    }
    if (situacao) {
      params = params.set('situacao', situacao);
    }
    if (proposta) {
      params = params.set('proposta', proposta);
    }
    if (ano) {
      params = params.set('ano', ano + '');
    }
    if (pac) {
      params = params.set('pac', pac);
    }
    if (comprador) {
      params = params.set('comprador', comprador);
    }

    return this.http.get(`${this.BASE_URL}/pesquisaAvancada/`, blockUi({params})).pipe(map(p => Object.assign(new ColecaoAditivo(), p)));
  }

  pesquisaAditivo(criterio: string): Observable<ColecaoAditivo> {
    let params = new HttpParams();
    if (criterio) {
      params = params.set('criterio', criterio);
    }
    return this.http.get(`${this.BASE_URL}/pesquisa/`, blockUi({params})).pipe(map(p => Object.assign(new ColecaoAditivo(), p)));
  }

  pesquisaAditivoInternaAvancada(instituicaoFinanceira: string, protocoloInicio: Date, protocoloFim: Date, situacao: string, fase: string, proposta: string, ano: number, pac: string, comprador: string): Observable<ColecaoAditivo> {
    function date2str(data: Date): string {
      if (data == null) {
        return null;
      }
      return formatDate(data, 'yyyy-MM-dd', 'en-US');
    }

    let params = new HttpParams();
    if (instituicaoFinanceira) {
      params = params.set('instituicaoFinanceira', instituicaoFinanceira);
    }
    if (protocoloInicio) {
      params = params.set('protocoloInicio', date2str(protocoloInicio));
    }
    if (protocoloFim) {
      params = params.set('protocoloFim', date2str(protocoloFim));
    }
    if (situacao) {
      params = params.set('situacao', situacao);
    }
    if (fase) {
      params = params.set('fase', fase);
    }
    if (proposta) {
      params = params.set('proposta', proposta);
    }
    if (ano) {
      params = params.set('ano', ano + '');
    }
    if (pac) {
      params = params.set('pac', pac);
    }
    if (comprador) {
      params = params.set('comprador', comprador);
    }

    return this.http.get(`${this.BASE_URL}/pesquisaInternaAvancada/`, blockUi({params})).pipe(map(p => Object.assign(new ColecaoAditivo(), p)));
  }

  pesquisaAditivoInterna(criterio: string): Observable<ColecaoAditivo> {
    let params = new HttpParams();
    if (criterio) {
      params = params.set('criterio', criterio);
    }
    return this.http.get(`${this.BASE_URL}/pesquisaInterna/`, blockUi({params})).pipe(map(p => Object.assign(new ColecaoAditivo(), p)));
  }

  analistaAprovarAditivoComRessalvas(idAditivo: number, comentario: string): Observable<ResultadoAprovacaoAditivo> {
    let params = new HttpParams();
    if (comentario) {
      params = params.set('comentario', comentario);
    }
    return this.http.post(`${this.BASE_URL}/${idAditivo}/aprovacaoComRessalvasAnalista`, blockUi(params)).pipe(map(a => Object.assign(new ResultadoAprovacaoAditivo(), a)));
  }

  analistaAprovarAditivo(idAditivo: number, comentario: string): Observable<ResultadoAprovacaoAditivo> {
    let params = new HttpParams();
    if (comentario) {
      params = params.set('comentario', comentario);
    }
    return this.http.post(`${this.BASE_URL}/${idAditivo}/aprovacaoAnalista`, blockUi(params)).pipe(map(a => Object.assign(new ResultadoAprovacaoAditivo(), a)));
  }

  analistaRejeitarAditivo(idAditivo: number, comentario: string, motivoDevolucao: string): Observable<ResultadoAprovacaoAditivo> {
    let params = new HttpParams();
    if (comentario) {
      params = params.set('comentario', comentario);
    }
    if (motivoDevolucao) {
      params = params.set('motivoDevolucao', motivoDevolucao);
    }
    return this.http.post(`${this.BASE_URL}/${idAditivo}/rejeicaoAnalista`, blockUi(params)).pipe(map(a => Object.assign(new ResultadoAprovacaoAditivo(), a)));
  }

  gerenteAprovarAditivo(idAditivo: number, comentario: string): Observable<ResultadoAprovacaoAditivo> {
    let params = new HttpParams();
    if (comentario) {
      params = params.set('comentario', comentario);
    }
    return this.http.post(`${this.BASE_URL}/${idAditivo}/aprovacaoGerente`, blockUi(params)).pipe(map(a => Object.assign(new ResultadoAprovacaoAditivo(), a)));
  }

  gerenteRejeitarAditivo(idAditivo: number, comentario: string): Observable<ResultadoAprovacaoAditivo> {
    let params = new HttpParams();
    if (comentario) {
      params = params.set('comentario', comentario);
    }
    return this.http.post(`${this.BASE_URL}/${idAditivo}/rejeicaoGerente`, blockUi(params)).pipe(map(a => Object.assign(new ResultadoAprovacaoAditivo(), a)));
  }

  gerenteReencaminharAditivo(idAditivo: number, comentario: string): Observable<ResultadoAprovacaoAditivo> {
    let params = new HttpParams();
    if (comentario) {
      params = params.set('comentario', comentario);
    }
    return this.http.post(`${this.BASE_URL}/${idAditivo}/reencaminhamentoGerente`, blockUi(params)).pipe(map(a => Object.assign(new ResultadoAprovacaoAditivo(), a)));
  }

  chefeAprovarAditivo(idAditivo: number, comentario: string): Observable<ResultadoAprovacaoAditivo> {
    let params = new HttpParams();
    if (comentario) {
      params = params.set('comentario', comentario);
    }
    return this.http.post(`${this.BASE_URL}/${idAditivo}/aprovacaoChefe`, blockUi(params)).pipe(map(a => Object.assign(new ResultadoAprovacaoAditivo(), a)));
  }

  chefeReencaminharAditivo(idAditivo: number, comentario: string): Observable<ResultadoAprovacaoAditivo> {
    let params = new HttpParams();
    if (comentario) {
      params = params.set('comentario', comentario);
    }
    return this.http.post(`${this.BASE_URL}/${idAditivo}/reencaminhamentoChefe`, blockUi(params)).pipe(map(a => Object.assign(new ResultadoAprovacaoAditivo(), a)));
  }

}
